/* Click identity forwarding: heilkompass-magazin.de -> vitaliskraft.de
   Carries the ad click id from the advertorial into the Shopify cart permalink,
   so the order records it even though no store page ever renders.
   Cart links accept only note/attributes/ref, so identity must ride as attributes[...].
   Installed 2026-08-14. v5. */
(function () {
  var HOST = 'vitaliskraft.de';
  var KEY = 'vk_click';
  var MAXAGE = 30 * 24 * 60 * 60 * 1000;
  var MARK = 'vksrc';
  var EXACT = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid'];
  var PREFIX = ['utm_', 'tw_'];

  function cookie(name) {
    var m = document.cookie.match('(^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[2]) : '';
  }

  /* fbc is fb.1.<ms>.<fbclid>, and an fbclid may itself contain dots. */
  function fbclidOf(v) {
    var p = String(v).split('.');
    return p.length > 3 ? p.slice(3).join('.') : '';
  }

  /* Identity of the click a payload represents, whichever network it came from. */
  function clickIdOf(d) {
    for (var i = 0; i < EXACT.length; i++) {
      if (d && d[EXACT[i]]) return EXACT[i] + ':' + d[EXACT[i]];
    }
    return '';
  }

  function fromUrl() {
    var out = {};
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (!v) return;
        k = k.toLowerCase();
        if (EXACT.indexOf(k) > -1) { out[k] = v; return; }
        for (var i = 0; i < PREFIX.length; i++) {
          if (k.indexOf(PREFIX[i]) === 0) { out[k] = v; return; }
        }
      });
    } catch (e) {}
    return out;
  }

  function read() {
    var raw = null;
    try { raw = localStorage.getItem(KEY) || sessionStorage.getItem(KEY); } catch (e) {}
    if (!raw) return null;
    try {
      var p = JSON.parse(raw);
      if (!p || !p.d || !p.t || Date.now() - p.t > MAXAGE) return null;
      return p;
    } catch (e) { return null; }
  }

  function write(p) {
    var s = JSON.stringify(p);
    try { localStorage.setItem(KEY, s); } catch (e) {}
    try { sessionStorage.setItem(KEY, s); } catch (e) {}
    return p;
  }

  var fresh = fromUrl();
  var prev = read();
  var touch;
  if (Object.keys(fresh).length) {
    /* Any new click id starts a new context. Merging would carry the previous
       campaign's utms onto it and credit the new click to the old ad. */
    var newClick = !!clickIdOf(fresh) && (!prev || clickIdOf(prev.d) !== clickIdOf(fresh));
    var merged = {}, k;
    if (prev && !newClick) for (k in prev.d) if (Object.prototype.hasOwnProperty.call(prev.d, k)) merged[k] = prev.d[k];
    for (k in fresh) if (Object.prototype.hasOwnProperty.call(fresh, k)) merged[k] = fresh[k];
    touch = write({ t: (newClick || !prev) ? Date.now() : prev.t, d: merged });
  } else {
    touch = prev || { t: Date.now(), d: {} };
  }

  function pairs(isCart) {
    var d = touch.d, out = [], k;
    for (k in d) if (Object.prototype.hasOwnProperty.call(d, k)) out.push([k, d[k]]);
    if (!isCart) { out.push([MARK, 'cta']); return out; }
    /* Two different situations, deliberately handled differently.
       When we know the current click, the cookie is used only if it is about that
       same click: the pixel rewrites _fbc after we run, so a returning visitor still
       holds the previous one, and shipping that would credit the wrong ad.
       When we know no click at all, the cookie is the only click evidence there is,
       and last known click beats sending nothing. */
    var ck = cookie('_fbc'), fbc = '';
    if (d.fbclid) {
      fbc = (ck && fbclidOf(ck) === d.fbclid) ? ck : 'fb.1.' + touch.t + '.' + d.fbclid;
    } else if (ck) {
      fbc = ck;
    }
    if (fbc) out.push(['fbc', fbc]);
    out.push(['src', 'vk-cta']);
    return out;
  }

  function isOurs(href) {
    try {
      var h = new URL(href, location.href).hostname.toLowerCase();
      return h === HOST || h.slice(-(HOST.length + 1)) === '.' + HOST;
    } catch (e) { return false; }
  }

  function decorate(a) {
    var href = a.getAttribute('href');
    if (!href || !isOurs(href)) return;

    /* Keep the pristine href so a link stamped under an earlier click can be
       restamped when a newer click arrives, instead of staying frozen on the old one. */
    var current = clickIdOf(touch.d);
    var orig = a.getAttribute('data-vk-orig');
    if (orig === null) {
      var alreadyMarked = href.indexOf('attributes%5Bsrc%5D') > -1 ||
                          href.indexOf('attributes[src]') > -1 ||
                          href.indexOf(MARK + '=') > -1;
      if (alreadyMarked) return;
      a.setAttribute('data-vk-orig', href);
    } else {
      if (a.getAttribute('data-vk-id') === current) return;
      href = orig;
    }

    var isCart = href.indexOf('/cart/') > -1;
    var list = pairs(isCart), parts = [], i;
    for (i = 0; i < list.length; i++) {
      var k = encodeURIComponent(list[i][0]);
      var v = encodeURIComponent(list[i][1]);
      parts.push(isCart ? 'attributes%5B' + k + '%5D=' + v : k + '=' + v);
    }
    if (!parts.length) return;

    /* Params must go before the fragment, or they end up inside the hash and never reach the server. */
    var hash = '', at = href.indexOf('#');
    if (at > -1) { hash = href.slice(at); href = href.slice(0, at); }
    a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + parts.join('&') + hash);
    a.setAttribute('data-vk-id', current);
  }

  function sweep() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) decorate(links[i]);
  }

  function refresh() {
    var p = read();
    if (p && clickIdOf(p.d) !== clickIdOf(touch.d)) touch = p;
    sweep();
  }

  /* Capture phase, so a link built after the last sweep is still stamped on the way out.
     auxclick covers middle click, which never fires click. */
  function onClick(e) {
    var n = e.target;
    while (n && n.nodeType === 1) {
      if (n.tagName === 'A') { decorate(n); return; }
      n = n.parentNode;
    }
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);

  /* A click landing in another tab writes storage; this tab's links must follow,
     or they keep pointing at the older click. Same for a bfcache restore. */
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  /* Replo hydrates after load; watch briefly, then stop. */
  try {
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; sweep(); }, 250);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); sweep(); }, 20000);
  } catch (e) {}
})();
